<template>
  <el-main class="layout-main">
    <keep-alive :max="maxTabs" :include="allKeepAliveRouters">
      <router-view
        :key="key"
        class="app-main"
        :class="{ 'app-main-android': isAndroid }"
        ref="main"
        v-show="!isIframeRouterView"
      />
    </keep-alive>
    <!-- iframe 页面 -->
    <component :is="Report" v-for="path in iframePaths" :key="path" v-show="path === key && isIframeRouterView" />
  </el-main>
</template>

<script>
  import { maxTabs, listeningPageChangeRouteNames, keepAliveRoutes } from '@/config'
  import { mapGetters, mapActions } from 'vuex'
  import Report from '@/views/report'
  import { isAndroid } from '@/utils/device'
  export default {
    name: 'Main',
    data() {
      return {
        isAndroid,
        maxTabs,
        Report,
        iframePaths: [],
      }
    },
    computed: {
      ...mapGetters({
        changePages: 'tabsBar/changePages',
        dynamicAliveRoutes: 'sys/dynamicAliveRoutes',
      }),
      key() {
        return this.$route.fullPath
      },
      // iframe 页面路由名称必须以 iframe- 开头
      isIframeRouterView() {
        return this.$route?.name?.toString().startsWith('iframe-')
      },
      allKeepAliveRouters() {
        return keepAliveRoutes.concat(this.dynamicAliveRoutes)
      },
    },
    watch: {
      $route: {
        handler(route) {
          // 收集iframe页面
          if (this.isIframeRouterView) {
            if (!this.iframePaths.includes(route.fullPath)) {
              this.iframePaths.push(route.fullPath)
            }
          }
        },
        immediate: true,
      },
      changePages(newVal, oldVal) {
        if (oldVal.length === 0 && newVal.length) {
          window.addEventListener('beforeunload', this.handleBeforeunload)
          return
        }
        if (newVal.length === 0) {
          window.removeEventListener('beforeunload', this.handleBeforeunload)
        }
      },
    },
    mounted() {
      // 监听页面元素内容是否改变
      const change = () => {
        if (!listeningPageChangeRouteNames.includes(this.$route.name)) return
        if (!this.changePages.includes(this.$route.name)) {
          this.setChangePages([this.$route.name, ...this.changePages])
        }
      }
      this.$el.addEventListener('change', change)
      this.$once('hook:beforeDestroy', () => {
        this.$el.removeEventListener('change', change)
      })
    },
    methods: {
      ...mapActions({
        setChangePages: 'tabsBar/setChangePages',
      }),
      handleBeforeunload(event) {
        event.preventDefault()
        event.returnValue = ''
      },
    },
  }
</script>

<style lang="scss" scoped>
  .layout-main {
    height: inherit;
    .app-main {
      box-sizing: border-box;
      max-height: calc(100% - 1px);
      height: calc(100vh - #{$mg-layout-header-height} - var(--layout-extra-top, 0px));
      overflow: auto;
      padding: 8px;
    }
    .app-main-android {
      height: 100vh !important;
    }
  }
</style>
